import React, { Component } from 'react'

export default class Button extends Component {

  render () {
    const { children, text, type, classes, clickButton } = this.props;
    let childs = [];
    if ( !children ) {
      childs.push(text);
    } else {
      childs.push(children);
    }

    return (
      <button type={type}
        className={"btn " + classes}
        onClick={clickButton}>
          {childs}
      </button>
    );
  }  
};


// WEBPACK FOOTER //
// ./src/components/Buttons/index.js